import React, {Fragment} from "react";
import PropTypes from "prop-types";

import Confirm from "../common/Confirm";
import Row from "../common/Row";
import AdresAutoComplete from "./AdresAutoComplete";

const AdresModal = (props) => {
	const {
		confirmAdres,
		adresModel,
		gemeenten,
		straten,
		huisnummers,
		busnummers,
		onGemeenteChange,
		onStraatChange,
		onHuisnummerChange,
		onBusnummerChange,
		straatEnabled,
		huisnummerEnabled,
		busnummerEnabled,
		errors,
		confirmDisabled
	} = props;

	let children = <Fragment>
		<Row>
			<AdresAutoComplete
				items={gemeenten || []}
				size={12}
				name="gemeente"
				label="Gemeente - Postcode"
				value={adresModel.gemeenteUUId}
				onChange={onGemeenteChange}
				validationMessage={errors ? errors['gemeente'] : ""}
			/>
		</Row>
		<Row>
			<AdresAutoComplete
				items={straten || []}
				size={12}
				name="straat"
				label="Straat"
				value={adresModel.straatId}
				onChange={onStraatChange}
				validationMessage={errors ? errors['straat'] : ""}
				disabled={!straatEnabled}
				valueKey="id"
				labelKey="naam"
			/>
		</Row>
		<Row>
			<AdresAutoComplete
				items={huisnummers || []}
				size={12}
				name="huisnummer"
				label="Huisnummer"
				value={adresModel.huisNummer}
				onChange={onHuisnummerChange}
				validationMessage={errors ? errors['huisnummer'] : ""}
				disabled={!huisnummerEnabled}
				minSearchLength={0}
				valueKey="huisnummer"
				labelKey="huisnummer"
				allowUnknownItems
			/>
		</Row>
		<Row>
			<AdresAutoComplete
				items={busnummers || []}
				size={12}
				name="busnummer"
				label="Busnummer"
				value={adresModel.busNummer}
				onChange={onBusnummerChange}
				validationMessage={errors ? errors['busnummer'] : ""}
				disabled={!busnummerEnabled}
				minSearchLength={0}
				valueKey="busnummer"
				labelKey="busnummer"
				allowUnknownItems
			/>
		</Row>
	</Fragment>;

	return(
		<Confirm title="Adres invoeren" showOnTop message=" " children={children} callback={confirmAdres} confirmDisabled={confirmDisabled} />
	);
};

AdresModal.propTypes = {
	confirmAdres: PropTypes.func,
	adresModel: PropTypes.object,
	gemeenten: PropTypes.array,
	straten: PropTypes.array,
	huisnummers: PropTypes.array,
	busnummers: PropTypes.array,
	onGemeenteChange: PropTypes.func,
	onStraatChange: PropTypes.func,
	onHuisnummerChange: PropTypes.func,
	onBusnummerChange: PropTypes.func,
	errors: PropTypes.array,
	straatEnabled: PropTypes.bool,
	huisnummerEnabled: PropTypes.bool,
	busnummerEnabled: PropTypes.bool,
	confirmDisabled: PropTypes.bool
};

export default AdresModal;
